module.exports = __webpack_public_path__ + "img/img1.a6cbe9bd.jpg";